import { homeNavMuted } from '@/features/home/styles/homeStyles'
import { palettePrimaryMain, surfaceAuthCard } from '@/theme/designTokens'

/** Figma 5715-11760 — notification bell dropdown */
export const notificationPanelPaperSx = {
  width: 388,
  maxWidth: 'calc(100vw - 32px)',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  border: '1px solid #E1E7EF',
  boxShadow: '0px 10px 15px -3px rgba(0,0,0,0.1), 0px 4px 6px -4px rgba(0,0,0,0.1)',
  overflow: 'hidden',
  mt: '20px',
  bgcolor: surfaceAuthCard,
} as const

export const notificationPanelHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  px: '16px',
  pt: '12px',
  pb: '13px',
  borderBottom: '1px solid #E1E7EF',
  flexShrink: 0,
} as const

export const notificationPanelTitleSx = {
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '20px',
  color: '#0F1729',
} as const

export const notificationPanelMarkAllSx = {
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  color: palettePrimaryMain,
  textTransform: 'none',
  p: 0,
  minWidth: 'auto',
  '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
  '&.Mui-disabled': { color: homeNavMuted },
} as const

export const notificationPanelListSx = {
  maxHeight: 288,
  overflowY: 'auto',
  flexShrink: 1,
  minHeight: 0,
  '&::-webkit-scrollbar': { width: 4 },
  '&::-webkit-scrollbar-thumb': { bgcolor: '#E1E7EF', borderRadius: 2 },
} as const

export const notificationPanelFooterSx = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  px: '16px',
  py: '12px',
  flexShrink: 0,
  borderTop: '1px solid #E1E7EF',
} as const

export const notificationPanelViewAllSx = {
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '20px',
  color: palettePrimaryMain,
  textTransform: 'none',
  p: 0,
  minWidth: 'auto',
  '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
} as const

export const notificationItemUnreadBg = '#F0F8FD'
export const notificationItemBorderColor = '#E2E8F0'
